// extracted by mini-css-extract-plugin
export default {"advancedToggleButton":"KSE6j","advancedToggleButton--expanded":"SUtsF"};